// extracted by mini-css-extract-plugin
export default {"infoIconButton":"infoIconButton__vs1PA"};